import type {
  ClientDetailResponseDto,
  ClientResponseDto,
  ClientsControllerListClientsParams,
  ClientStatsResponseDto,
  CreateClientDto,
  UpdateClientDto,
} from '@trellis/api'
import type { CreateClient, UpdateClient } from '@trellis/shared'

import { apiClient } from '@/lib/api-client'
import { request, requestPaged } from '@/lib/request'

export type ClientsListParams = ClientsControllerListClientsParams

export const listClients = (params: ClientsListParams = {}) =>
  requestPaged<ClientResponseDto>(() =>
    apiClient.api.clientsControllerListClients(params),
  )

export const createClient = (data: CreateClient) =>
  // The shared CreateClient type reflects Zod's parsed output (optional fields may be
  // undefined after transforms); the generated CreateClientDto marks them as required.
  // The runtime value is valid — cast bridges the OpenAPI type gap.
  request<ClientDetailResponseDto>(() =>
    apiClient.api.clientsControllerCreateClient(data as unknown as CreateClientDto),
  )

export const updateClient = (id: string, data: UpdateClient) =>
  // UpdateClient has optional contact sub-fields from the shared Zod schema; UpdateClientDto
  // marks them required. The runtime value is valid — cast bridges the OpenAPI type gap.
  request<ClientDetailResponseDto>(() =>
    apiClient.api.clientsControllerUpdateClient(
      { id },
      data as unknown as UpdateClientDto,
    ),
  )

export const deleteClient = (id: string) =>
  request<void>(() => apiClient.api.clientsControllerDeleteClient({ id }))

export const getClient = (id: string) =>
  request<ClientDetailResponseDto>(() =>
    apiClient.api.clientsControllerFindClient({ id }),
  )

export const getClientStats = (id: string) =>
  request<ClientStatsResponseDto>(() =>
    apiClient.api.clientsControllerGetClientStats({ id }),
  )

export const assignTagsToClient = (clientId: string, tagIds: string[]) =>
  request<void>(() =>
    apiClient.api.clientsControllerAssignTags({ id: clientId }, { tagIds }),
  )

export const removeTagFromClient = (clientId: string, tagId: string) =>
  request<void>(() => apiClient.api.clientsControllerRemoveTag({ id: clientId, tagId }))
